export default {
    "title": "Servicios / {{client}}",
    "description": "Servicios web disponibles para integración",
    "apiToken": "API token",
    "apiUrl": "API URL",
    "active": "Activo",
    "inactive": "Inactivo",
    "copied": "Copiado",
    "copyError": "Error al copiar",
    "noServices": "No hay servicios configurados para este cliente",
    "downloadPDF": "Descargar PDF",
    "stocks": {
        "name": "Existencias",
        "description": "Consulta el estado de las existencias de forma automatizada vía API, utilizando los siguientes parámetros:",
        "guide": "Descarga la guía de uso de este servicio para más información."
    }
};
